import {
  PaymentMethod
} from "../chunk-3P4ZAE2Z.js";

// customer-capabilities/customer-capabilities.schema.ts
import { z } from "zod";
var AllowedPaymentMethodsSchema = z.array(z.nativeEnum(PaymentMethod));
var FeatureFlagsSchema = z.record(z.string(), z.boolean());
var CapabilitiesSchema = z.record(z.string(), z.boolean());
var EmbedPaymentOverridesSchema = z.record(z.string().min(1), AllowedPaymentMethodsSchema);
var CustomerCapabilitiesSchema = z.object({
  id: z.string().uuid(),
  b2bwaveCustomerId: z.number().int(),
  supabaseUserId: z.string().uuid().nullable(),
  allowedPaymentMethods: AllowedPaymentMethodsSchema,
  featureFlags: FeatureFlagsSchema.nullable(),
  capabilities: CapabilitiesSchema.nullable(),
  embedPaymentOverrides: EmbedPaymentOverridesSchema.nullable(),
  notes: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var DEFAULT_PAYMENT_METHODS = ["ach" /* ACH */];
export {
  AllowedPaymentMethodsSchema,
  CapabilitiesSchema,
  CustomerCapabilitiesSchema,
  DEFAULT_PAYMENT_METHODS,
  EmbedPaymentOverridesSchema,
  FeatureFlagsSchema,
  PaymentMethod
};
